import React from "react";

const Card = ({ children }) => {
  return (
    <div className="rounded-lg shadow bg-white p-4 h-full w-full">
      {children}
    </div>
  );
};

export default Card;
